module.exports = __webpack_public_path__ + "img/texte_stdout.d7886f76.png";